import {
  BooleanParam,
  DateRangeParam,
  NullableStringArrayParam,
  NumberParam,
  QueryParamConfigMap,
  StringArrayParam,
  StringParam,
  withDefault,
} from 'common/hooks/customSearchParams';
import { UnwatchedState } from './Containers/types';

export const DEFAULT_DATE_RANGE_PARAM = {
  startDate: null,
  endDate: null,
  includeStartDate: null,
  includeEndDate: null,
  exactDate: null,
};

export const SHIPMENTS_QUERY_PARAMS: QueryParamConfigMap = {
  availableForPickup: BooleanParam,
  billOfLadingNumbers: withDefault(StringArrayParam, []),
  closedArea: BooleanParam,
  containerNumbers: withDefault(StringArrayParam, []),
  containerStatus: withDefault(StringArrayParam, []),
  containerType: withDefault(StringArrayParam, []),
  customers: withDefault(NullableStringArrayParam, []),
  demurrageDue: BooleanParam,
  focusedContainer: StringParam,
  gatedInAt: DateRangeParam,
  gatedOutAt: DateRangeParam,
  hasPerDiemFees: BooleanParam,
  holdTypes: withDefault(StringArrayParam, []),
  importStatus: withDefault(StringArrayParam, []),
  lastFreeDayAt: DateRangeParam,
  page: withDefault(NumberParam, 1),
  pageSize: withDefault(NumberParam, 25),
  portPickupCodes: withDefault(StringArrayParam, []),
  shippingLine: withDefault(StringArrayParam, []),
  status: withDefault(StringArrayParam, []),
  terminalPickupKeys: withDefault(StringArrayParam, []),
  sortBy: StringParam,
  sortDirection: StringParam,
  estPerDiemLfd: DateRangeParam,
  unwatchedState: withDefault(StringParam, UnwatchedState.OnlyWatched),
  deletedBy: withDefault(NullableStringArrayParam, []),
  deletedOn: DateRangeParam,
};

export const ADD_SHIPMENTS_QUERY_PARAMS: QueryParamConfigMap = {
  bols: withDefault(StringArrayParam, []),
  containerNumbers: withDefault(StringArrayParam, []),
  customers: withDefault(NullableStringArrayParam, []),
  page: withDefault(NumberParam, 1),
  pageSize: withDefault(NumberParam, 25),
  trackingStatus: withDefault(StringArrayParam, []),
};
